// extracted by mini-css-extract-plugin
export default {"btn":"_796AqwOFs_","minimal":"_1bLZvI40oA","btnStart":"_1SrCTG7yDt","loadingContainer":"_39VuJRXAmL"};